export namespace AddNegatives {
    export type ItemType = 'nGram' | 'searchTerm'
    export const FormattedItemType = {
        nGram: 'N-Gram',
        searchTerm: 'Search Term',
    } as const satisfies Record<ItemType, string>
}
